import {
  CommonListingRequiredVisibleInfo,
  ListingRequiredVisibleInfo,
} from 'models/Listing';

export type ListingFieldBaseName = {
  [K in keyof ListingRequiredVisibleInfo]: K extends `${infer Base}RequiredVisibleInfo`
    ? Base
    : never;
}[keyof ListingRequiredVisibleInfo];

export type CommonListingFieldBaseName = {
  [K in keyof CommonListingRequiredVisibleInfo]: K extends `${infer Base}RequiredVisibleInfo`
    ? Base
    : never;
}[keyof CommonListingRequiredVisibleInfo];

export const PROFITABLE_DEFAULT_REQUIRED: Record<
  ListingFieldBaseName,
  boolean
> = {
  amountFrom: true,
  amountTo: true,
  amount: true,
  revenue: true,
  COGS: false,
  lessOverheads: false,
  EBITDA: true,
  depreciationAndAmortisation: false,
  EBIT: false,
  accountingPeriod: true,
  averageStockValue: false,
  succession: false,
  hasCommercialProperty: false,
  revenueModel: true,
} as const;

export const URGENT_DEFAULT_REQUIRED: Record<
  CommonListingFieldBaseName,
  boolean
> = {
  revenue: false,
  EBITDA: false,
  averageStockValue: false,
} as const;

export const getIsDefaultRequired = (
  key: CommonListingFieldBaseName | ListingFieldBaseName,
  isUrgent = false,
) => {
  return (
    (isUrgent ? URGENT_DEFAULT_REQUIRED : PROFITABLE_DEFAULT_REQUIRED)?.[
      key as CommonListingFieldBaseName
    ] || false
  );
};
